/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/checkbox-button/custom-elements';

import { defineCustomElement as defineOsdsCheckboxButton } from '@ovhcloud/ods-stencil/components/checkbox-button/custom-elements/osds-checkbox-button.js';

export const OsdsCheckboxButton = /*@__PURE__*/createReactComponent<JSX.OsdsCheckboxButton, HTMLOsdsCheckboxButtonElement>('osds-checkbox-button', undefined, undefined, defineOsdsCheckboxButton);
